import ApiService from "@/core/services/api.service";

const actions = {
  /**
   * Add teacher in facial device
   * @param context
   * @param payload
   * @returns {*}
   */
  addTeacherInFacialDevice(context, payload) {
    ApiService.setHeader();
    return ApiService.post("school/device/facial/teacher", payload).then(
      (response) => response
    );
  },
};

export default {
  actions,
};
